module.exports = __webpack_public_path__ + "img/visa-mastercard-amex.59f82498.png";